export default {
    updateAttendance: 'Edit Attendance',
    cancel: 'Cancel',
    save: 'Save',
    profile: 'Profile',
    status: 'Status',
    date: 'Date',
    checkinTime: 'Check in time',
    employeeId: 'Employee ID',
    employeeFullname: 'Name Surname',
    email: 'Email address',
    position: 'Position',
    bureau: 'ฺBureau',
    activityLog: 'Activity Log',
    thereIsNoActivityLog: 'There is no activity log',
    congratulation: 'Congratulation',
    errorMessage: 'Something went wrong',
    thisFieldIsRequired: 'This field is required',
    errorSelectTime: 'Error select time',
    activityMessage: 'Updated Checkin : $checkinTime by user : $userName'
}
